import React from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import CDInput from 'components/cd-input'
import TextArea from 'components/text-area'
import CDImage from 'components/cd-image-upload'
import CDButton from 'components/cd-button'
import NativeSelect from '../components/native-select'
import { categoriesApi } from '../restaurant.api'
import { useCategories } from './categories.context'

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
]

const validationSchema = Yup.object({
  name: Yup.string().required('Category name is required'),
})

const toInitialValues = (category) => ({
  name: category?.name || '',
  icon: category?.icon || '',
  description: category?.description || '',
  status: category?.status || 'active',
  image: category?.image || '',
})

function CategoryForm({ category, onClose }) {
  const { refresh } = useCategories()
  const isEditing = !!category?._id

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = { ...values }
    delete payload.imageName // set by cd-image-upload, not part of the model

    const { response } = isEditing
      ? await categoriesApi.update(category._id, payload)
      : await categoriesApi.create(payload)

    setSubmitting(false)
    if (response?.success) {
      await refresh()
      onClose()
    }
  }

  return (
    <Formik
      initialValues={toInitialValues(category)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form className='tw-flex tw-flex-col tw-gap-4'>
          <CDInput name='name' label='Category name' required />
          <CDInput name='icon' label='Icon (emoji)' placeholder='🍔' />
          <TextArea name='description' label='Description' />
          <NativeSelect name='status' label='Status' options={STATUS_OPTIONS} />
          <CDImage name='image' label='Category image' />

          <div className='tw-flex tw-gap-3 tw-mt-2'>
            <CDButton
              type='submit'
              processing={formik.isSubmitting}
              label={isEditing ? 'Save changes' : 'Create category'}
            />
            <button
              type='button'
              onClick={onClose}
              className='tw-px-[24px] tw-py-[8px] tw-rounded-[6px] tw-border tw-border-gray-300 tw-text-gray-600 tw-text-regular'
            >
              Cancel
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default CategoryForm
